import ENV from "config/Env";
import { backendQueryKey, localQueryKey, permanentBackendQueryKey } from "hooks/useTypedQuery";

import type { Dealer, DealerID, DealerLocation, DealerLocationID, ImportLogID, Language, TyreTeamCredential } from "models";

export enum DEALER_STATUSES {
  All = 1,
  Active,
  Inactive
}

export type DealersDashboardFilter = {
  term: string;
  status: DEALER_STATUSES | null;
  areLocationsExpanded: boolean;
};

export type ImportLog = {
  created_on: string;
  updated_on: string;
  import_log_id: ImportLogID;
  appointment_id: number;
  external_id: string;
  wo_nr: string;
};

export type PlanitEstablishment = {
  Id: number;
  Name: string;
  DealerLocationID: DealerLocationID;
};

const component = "DealersDashboard";

export const DealersDashboardQueryKeys = {
  filters: localQueryKey<DealersDashboardFilter>({ component, data: "dealersDashboardFilter" }),
  list: permanentBackendQueryKey<Dealer[]>({
    component,
    baseUrl: ENV.dealerBaseURL,
    endpoint: "/dealers/list",
    params: { embed: "dealer_location,number_of_missing_exact_licenses" }
  }),
  dealerDetails: (id?: DealerID) => backendQueryKey<Dealer>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/dealers/details", params: { id } }),
  locationDetails: (id?: DealerLocationID) => backendQueryKey<DealerLocation>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/locations/details", params: { id } }),
  importLog: (location_id?: DealerLocationID) =>
    backendQueryKey<ImportLog[]>({ component, baseUrl: ENV.systemBaseURL, endpoint: "/support/import_location_logs", params: { location_id } }),
  planitEstablishments: (dealer_id?: DealerID) =>
    backendQueryKey<PlanitEstablishment[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/planit/locations", params: { dealer_id } }),
  tyreTeamCredentials: (dealer_location_id?: DealerLocationID) =>
    backendQueryKey<TyreTeamCredential[]>({ component, baseUrl: ENV.tyreTeamBaseURL, endpoint: "/credentials/list", params: { dealer_location_id } }),
  languages: backendQueryKey<Language[]>({ component, baseUrl: ENV.systemBaseURL, endpoint: "/languages/list" })
};
